import React, {useEffect, useState, useRef} from 'react';
//components
import View from './password-card-view';
import Edit from './password-card-edit';
//utils
import {UserService} from '../../../utils/data-transfer';
import AuthorisationService from '../../../utils/authorisation/authorisationService';

const _userService = new UserService();

const PasswordCardContainer = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [state, setState] = useState({
    isLoading: true,
    userDetails: null
  });
  const isMounted = useRef(true);

  useEffect(() => {
    getUserDetails().then(data => {
      if(isMounted.current) {
        setState((prevState)  => ({
          ...prevState,
          isLoading: false,
          userDetails: data
        }));
      }
    });
    return () => {
      isMounted.current = false; // use effect cleanup to set flag false, if unmounted
    }
  }, []);

  const getUserDetails = async() =>{
    try {
      let user = await AuthorisationService.getUser();
      let userDetails = await _userService.getUserDetails(user.profile.sub);
      return userDetails;
    } catch (ex) {
      console.log(ex);
      this.props.history.push('/error?errorMessage=An unexpected error occurred when trying to view your profile.\nPlease try again shortly.\nIf this error persists please Contact Us.');
    }
  };

  const setUserPassword = async(password) => {
    try {
      await _userService.setUserPassword(state.userDetails.userId,password);
      toggleEdit();
    } catch (ex) {
      console.log(ex);
      this.props.history.push('/error?errorMessage=An unexpected error occurred when trying to update your profile.\nPlease try again shortly.\nIf this error persists please Contact Us.');
    }  
  };

  const toggleEdit = () => {
    if(isMounted.current) {
      setIsEdit(!isEdit);
    }
  };

  return (
    isEdit ? <Edit {...state} setUserPassword={setUserPassword} toggleEdit={toggleEdit}/> : <View {...state} toggleEdit={toggleEdit}/>
  )
};

export default PasswordCardContainer;